// extracted by mini-css-extract-plugin
module.exports = {"avatar":"user-avatar-module--avatar--3yw0i","small":"user-avatar-module--small--2BP8g"};